import { deployments } from './deployments.constants.ts';
import type { TStageEnvironment } from './deployments.types.ts';
import { isKeyOf } from '#utils/index.ts';

export const resolveEnvironment = (value?: string): TStageEnvironment => {
  if (!value) {
    return 'local';
  }

  if (!isKeyOf(deployments, value)) {
    throw new Error(
      `Unknown environment "${value}"; expected one of ${Object.keys(deployments).join(', ')}`,
    );
  }

  return value;
};
